import { render } from "./SlideNavigation.vue?vue&type=template&id=2a1b9f90&scoped=true"
import script from "./SlideNavigation.vue?vue&type=script&lang=js"
export * from "./SlideNavigation.vue?vue&type=script&lang=js"

import "./SlideNavigation.vue?vue&type=style&index=0&id=2a1b9f90&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a1b9f90"]])

export default __exports__